import { Component, ElementRef, NgZone, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { AlertService } from 'src/app/providers/alert.service';
import { ApiService } from 'src/app/providers/api.service';
import { AuthService } from 'src/app/providers/auth.service';
import { LoaderServiceService } from 'src/app/providers/loader-service.service';
import { NavigationService } from 'src/app/providers/navigation.service';
import { StorageService } from 'src/app/providers/storage.service';
import { SM_CONSTANTS } from 'src/app/shared/constants/sm-constants';
import { COUNTRY_CODES } from 'src/app/shared/data/country-codes';

@Component({
  selector: 'sm-personal-profile',
  templateUrl: './personal-profile.component.html',
  styleUrls: ['./personal-profile.component.scss']
})
export class PersonalProfileComponent implements OnInit, OnDestroy {
  @ViewChild('submitButton', {read: ElementRef ,static: true})
  submitButton!: ElementRef<HTMLButtonElement>;
  signInForm!: FormGroup;
  countryList: {name: string; dial_code: string; code: string; flag: string; preferred?: any;}[] = COUNTRY_CODES;
  countryCode: FormControl;
  phoneControl: FormControl;
  name: FormControl;
  dob: FormControl;
  gender: FormControl;
  address: FormControl;
  sendingOtpStatus: boolean = false;
  otpReceived: boolean = false;

  private _apiSubscription: Subscription;


  constructor(
    private _navService: NavigationService,
    private _router: Router,
    private _authService: AuthService,
    private _alertService: AlertService,
    private _apiService: ApiService,
    private _storageService: StorageService,
    private ngZone : NgZone,
    private loaderservice: LoaderServiceService
  ) {
    this._navService.hideSidebarAndNav = true;
    this.countryCode = new FormControl('', Validators.required);
    this.phoneControl = new FormControl('', [Validators.required, Validators.minLength(10)]);
    this.name = new FormControl('', [Validators.required]);
    this.dob = new FormControl('');
    this.gender = new FormControl('', [Validators.required]);
    this.address = new FormControl('', [Validators.required]);

    this._apiSubscription = this._apiService.apiResult.subscribe(resData => {
      if (resData.responseType === SM_CONSTANTS.RESULT_API_UPDATE_USER_PROFILE) {
        console.log(resData);
        if (resData.result.errorcode==0) {
          this.loaderservice.showLoader = false
          this._router.navigateByUrl('/dashboard').then(_ => {
            this._alertService.onOpenSnackbar('Account created successfully');
          });
        }
      }
    });
  }

  ngOnInit(): void {
    this.signInForm = new FormGroup({
      'name': this.name,
      'dob': this.dob,
      'gender': this.gender,
      'address': this.address
    });
    this._authService.initRecaptcha(this.submitButton.nativeElement)
  }


  onSendOTP(){
    console.log(this.userPhoneNumber);
    this.sendingOtpStatus = true;
    this._authService.onReceiveOTP(this.userPhoneNumber).then(res =>{
      this.sendingOtpStatus = !res;
      this.otpReceived = res;
    });
  }

  private get userPhoneNumber(){
    return (this.signInForm.value['country'].dial_code + this.signInForm.value['phone']).toString();
  }

  onSignIn(){

    let data = {
      profileInfo: {
        name: this.signInForm.value.name,
        phone: localStorage.getItem(SM_CONSTANTS.KEY_ACCOUNT_PHONE_NUMBER),
        gender: this.signInForm.value.gender,
        dob: this.signInForm.value.dob ? this.formatDate((new Date(this.signInForm.value.dob)).toLocaleDateString()):null,
        userType: 1,
        searchType: 1,
        addressInfo: {},
          origin: 'business'

      }
    }

    data.profileInfo.addressInfo = {
      addressLine : this.formattedAddress,
      city : (this.selectedLocation.city && this.selectedLocation.city != 'null') ? this.selectedLocation.city : 'null',
      state : (this.selectedLocation.state && this.selectedLocation.state != 'null') ? this.selectedLocation.state : 'null',
      country : (this.selectedLocation.country && this.selectedLocation.country != 'null') ? this.selectedLocation.country : 'null',
      zip : (this.selectedLocation.zip && this.selectedLocation.zip != 'null') ? this.selectedLocation.zip : 'null',
      lat : (this.lat && this.lat != 'null') ? this.lat : 'null',
      lng : (this.lng && this.lng != 'null') ? this.lng : 'null' 
    }
    Object.keys(data.profileInfo).forEach(key => {
      if ((data.profileInfo as any)[key] === null) {
        delete (data.profileInfo as any)[key];
      }
    });
    console.log(data);

    this.loaderservice.showLoader = true
    this._apiService.updateUserProfile(data)
    
    
  }


  ngOnDestroy(){
    this._apiSubscription.unsubscribe();
  }

  /**LOCATION AUTOCOMPLETE FUNCTION */
  GoogleAutocomplete = new google.maps.places.AutocompleteService();
  geocoder = new google.maps.Geocoder();
     autocompleteItems:any = [];
     selectedLocation : any = [];
   formattedAddress : any;
   lat:any;
   lng:any;
  updateSearchResults() {
    console.log("Text enter")
    if ( this.signInForm.value.address == '' || this.signInForm.value.address == null)
    {
        this.autocompleteItems = [];
        return;
    }
    this.GoogleAutocomplete.getPlacePredictions( {
        input: this.signInForm.value.address
    },
        ( predictions:any, status:any ) => {
  
          console.log(predictions,status);
            this.autocompleteItems = [];
            predictions.forEach( ( prediction:any ) => {
                this.autocompleteItems.push( prediction );
            } );
        } );
  }
  selectSearchResult( item:any ) {
    console.log(item);
    this.autocompleteItems = [];
    this.geocoder.geocode( {
        'placeId': item.place_id
    }, ( results:any, status:any ) => {
        if ( status === 'OK' && results[ 0 ] )
        {
            this.ngZone.run( () => {
                // this.personalInfoForm.value.address = results[ 0 ].formatted_address;
                this.signInForm.patchValue({
                  address: results[0].formatted_address
                })
                // this.locationSelected = true;
                let location_set:any = JSON.stringify(results[0].geometry);
                location_set=JSON.parse(location_set)
                let position = {
                    lat: results[ 0 ].geometry.location.lat,
                    lng: results[ 0 ].geometry.location.lng
                };
                this.lat=location_set.location.lat;
                this.lng=location_set.location.lng;
                console.log(this.lat,this.lng);
                console.log('Latitude & Langitude' , position)
                this.storeLocation( results[ 0 ].address_components, results[ 0 ].formatted_address );
            } );
        }
    } )
  }
  storeLocation( location:any, formatted_address:any ) {
    console.log(location);
    
    const selectedLocation: any = {};
    location.forEach( (element:any) => {
        console.log( element, element.types.includes( "postal_code" ) )
        if ( element.types.includes( "postal_code" ) )
        {
            selectedLocation.zip = element.long_name
        } else if ( element.types.includes( "country" ) )
        {
            selectedLocation.country = element.long_name
        } else if ( element.types.includes( "administrative_area_level_1" ) )
        {
            selectedLocation.state = element.long_name
        } else if ( element.types.includes( "locality" ) )
        {
            selectedLocation.city = element.long_name
        } else if ( element.types.includes( "route" ) )
        {
            selectedLocation.address = element.long_name
        }
    } );
      this.formattedAddress = formatted_address;
      this.selectedLocation = selectedLocation;
  }

  formatDate(originalDate: string): string {
    const parts = originalDate.split('/');
    const day = +parts[0];
    const month = +parts[1] - 1; // Months are 0-based in JavaScript
    const year = +parts[2];
    const date = new Date(year, month, day);

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0'); // Adding 1 to month since it's 0-based
    const dd = String(date.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
  }

}

